import React from 'react'
import ReceptionApp from '../../features/reception/Reception'
export default function Reception() {
  return (<ReceptionApp/> )
}
